import * as types from '../mutation-types'
import vueCookie from 'vue-cookie'

// initial state
const state = {
    helpLang : window._lang.helpLang,
    oddsConversionLang : window.lang.oddsConversionLang,
    int_page: 1,
    arr_lang: window.lang,
    arr_gameType: window.gameType,
    bool_isActive:true,
    randNum: window.randNum,
}

// getters
const getters = {
    randNum: state => state.randNum,
    helpLang: state => state.helpLang,
    oddsConversionLang: state => state.oddsConversionLang,
    int_page: state => {
        return state.int_page
    },
    arr_lang: state => {
        return state.arr_lang
    },
    arr_gameType: state => {
        return state.arr_gameType
    },
    bool_isActive: state =>{
        return state.bool_isActive
    }
}

// actions
const actions = {
}

// mutations
const mutations = {
    fn_change_page (state, payload) {
        state.int_page = payload
    },
    fn_check_lang(state){
        if(vueCookie.get('S0001_lang') == "en_US"){
            state.bool_isActive = false
        }
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/score/vue/store/modules/help.js